
const prefix = 'account';
module.exports.EVENTS_ACCOUNT = {
  STATUS_CHANGED: `${prefix}.status_changed`,
}; 